import { PromptType } from '../Types/prompt';
import {
  generateRecommendationPromptPathUrl,
  PromptTypePathUrl,
  PromptTypesPathUrl,
} from '../util/routesUrls';
import { API_URL, enrichedFetch } from './api';

export const generateRecommendationPrompt = async (userPrompt: string): Promise<string> => {
  return enrichedFetch(`${API_URL}/${generateRecommendationPromptPathUrl()}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ userPrompt }),
  }) as Promise<string>;
};

export const postPromptType = async (type: string): Promise<PromptType> => {
  return enrichedFetch(`${API_URL}/${PromptTypesPathUrl()}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ label: type }),
  }) as Promise<PromptType>;
};

export const patchPromptType = async (id: string, type: string): Promise<PromptType> => {
  return enrichedFetch(`${API_URL}/${PromptTypePathUrl(id)}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ label: type }),
  }) as Promise<PromptType>;
};

export const deletePromptType = async (id: string): Promise<void> => {
  return enrichedFetch(`${API_URL}/${PromptTypePathUrl(id)}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
  }) as Promise<void>;
};
